/**
 * Buy Bonus Popup
 */
buyBonusPopup = {};
buyBonusPopup.infoText = undefined;
buyBonusPopup.open = false;

buyBonusPopup.show = function (callback) {
  buyBonusPopup.open = true;

  // buyBonusPopup.showTimeline.play(0);

  buyBonusPopup.yesButton.enableButton(true);
  buyBonusPopup.noButton.enableButton(true);

  messageBus.post("game:modal", { reason: "buy_bonus" });

  const bonusBuyStakes =
    buyBonusPopup.gameConfig.data.slotConfig.gameModes.BONUS_BUY.coinSizes;
  const stakeController = resourceManager.getController("stakeController");
  const crtBaseStake = stakeController.getBaseStake();
  const numLines = stakeController.CurrentWinLineCount;

  const index = bonusBuyStakes.findIndex(
    (stake) => stake * numLines === crtBaseStake
  );

  if (index !== -1) {
    buyBonusPopup.currentStakeIndex = index;
  } else {
    buyBonusPopup.currentStakeIndex = bonusBuyStakes.length - 1;
  }

  if (buyBonusPopup.infoText !== undefined) {
    let text = buyBonusPopup.infoText._text;
    if (text.includes("12")) {
      text = text.replace("12", "8");
      buyBonusPopup.infoText.setText(text);
    }
  }

  buyBonusPopup.updatePopup();

  buyBonusPopup.container.visible = true;
  buyBonusPopup.callback = callback;
};

buyBonusPopup.updatePopup = function () {
  if (buyBonusPopup.currentStakeIndex === -1) {
    buyBonusPopup.stakePreviousButton.enableButton(false);
    buyBonusPopup.stakeNextButton.enableButton(false);
    buyBonusPopup.yesButton.enableButton(false);
  } else {
    const bonusBuyStakes =
      buyBonusPopup.gameConfig.data.slotConfig.gameModes.BONUS_BUY.coinSizes;

    buyBonusPopup.stakePreviousButton.enableButton(
      buyBonusPopup.currentStakeIndex > 0
    );
    buyBonusPopup.stakeNextButton.enableButton(
      buyBonusPopup.currentStakeIndex < bonusBuyStakes.length - 1
    );

    let baseStake = buyBonusPopup.convertToTotalStake(
      bonusBuyStakes[buyBonusPopup.currentStakeIndex]
    );
    buyBonusPopup.baseStakeText.setText(gdk.formatCurrency(baseStake));

    let cost = baseStake * buyBonusPopup.gameConfig.data.buyBonusCost;
    buyBonusPopup.betValueText.setText(gdk.formatCurrency(cost));
    buyBonusPopup.yesButton.enableButton(buyBonusPopup.balance >= cost);
  }
};

buyBonusPopup.create = function (json) {
  return new PIXI.Container();
};

buyBonusPopup.convertToTotalStake = function (coinSize) {
  let stakeController = resourceManager.getController("stakeController");
  return coinSize * stakeController.CurrentWinLineCount;
};

buyBonusPopup.onStakeNextPressed = function () {
  const bonusBuyStakes =
    buyBonusPopup.gameConfig.data.slotConfig.gameModes.BONUS_BUY.coinSizes;
  buyBonusPopup.currentStakeIndex = Math.min(
    buyBonusPopup.currentStakeIndex + 1,
    bonusBuyStakes.length - 1
  );
  buyBonusPopup.updatePopup();

  soundManager.play("buttonPressed");
};

buyBonusPopup.onStakePreviousPressed = function () {
  buyBonusPopup.currentStakeIndex = Math.max(
    buyBonusPopup.currentStakeIndex - 1,
    0
  );
  buyBonusPopup.updatePopup();

  soundManager.play("buttonPressed");
};

buyBonusPopup.initialise = function (json, container) {
  buyBonusPopup.container = container;
  buyBonusPopup.container.visible = false;

  buyBonusPopup.fadedMask = new PIXI.Graphics();
  buyBonusPopup.fadedMask.beginFill(0, 0.8);
  buyBonusPopup.fadedMask.drawRect(-10000, -10000, 20000, 20000);
  buyBonusPopup.fadedMask.endFill();
  buyBonusPopup.container.addChild(buyBonusPopup.fadedMask);

  messageBus.subscribe("spinner:GameConfigEvent", buyBonusPopup.onGameConfig);
  messageBus.subscribe("common:BalanceEvent", buyBonusPopup.onBalanceEvent);
  messageBus.subscribe("game:modal", buyBonusPopup.onModal);
  Reflex.registerEventHandler(
    "orientationChange",
    buyBonusPopup.orientationChange
  );

  buyBonusPopup.helpActive = false;
};

buyBonusPopup.onModal = function (data) {
  if (buyBonusPopup.container.visible) {
    if (data.reason && data.reason === "Options menu open") {
      buyBonusPopup.helpActive = true;

      buyBonusPopup.yesButton.enableButton(false);
      buyBonusPopup.noButton.enableButton(false);

      buyBonusPopup.stakePreviousButton.enableButton(false);
      buyBonusPopup.stakeNextButton.enableButton(false);
    } else if (buyBonusPopup.helpActive || data.reason === "help menu closed") {
      buyBonusPopup.helpActive = false;

      buyBonusPopup.yesButton.enableButton(true);
      buyBonusPopup.noButton.enableButton(true);

      buyBonusPopup.updatePopup();
    }

    if (buyBonusPopup.open) {
      if (data.reason === undefined) {
        messageBus.post("game:modal", { reason: "buy_bonus" });
      }
    }
  }
};

buyBonusPopup.init = function () {
  buyBonusPopup.background = resourceManager.get(
    "buyABonusContainer:buyBonusPopup:buyABonusBackground"
  );

  buyBonusPopup.yesButton = resourceManager.get(
    "buyABonusContainer:buyBonusPopup:yesButton"
  );
  buyBonusPopup.yesButton.onPressedCallback = buyBonusPopup.onClickedYes;

  buyBonusPopup.noButton = resourceManager.get(
    "buyABonusContainer:buyBonusPopup:noButton"
  );
  buyBonusPopup.noButton.onPressedCallback = buyBonusPopup.onClickedNo;

  buyBonusPopup.stakePreviousButton = resourceManager.get(
    "buyABonusContainer:buyBonusPopup:buyABonusBackground:stakePrevious"
  );
  buyBonusPopup.stakePreviousButton.onPressedCallback =
    buyBonusPopup.onStakePreviousPressed;

  buyBonusPopup.stakeNextButton = resourceManager.get(
    "buyABonusContainer:buyBonusPopup:buyABonusBackground:stakeNext"
  );
  buyBonusPopup.stakeNextButton.onPressedCallback =
    buyBonusPopup.onStakeNextPressed;

  buyBonusPopup.baseStakeText = resourceManager.get(
    "buyABonusContainer:buyBonusPopup:buyABonusBackground:baseStakeText"
  );

  buyBonusPopup.infoText = resourceManager.get(
    "buyABonusContainer:buyBonusPopup:buyABonusBackground:infoText"
  );

  buyBonusPopup.betValueText = resourceManager.get(
    "buyABonusContainer:buyBonusPopup:buyABonusBackground:buyBonusHintValue"
  );

  // const bottom = resourceManager.get(
  //   "buyABonusContainer:buyBonusPopup:frameBottom"
  // );

  // const border = resourceManager.get(
  //   "buyABonusContainer:buyBonusPopup:buyABonusBackground:canvas"
  // );

  buyBonusPopup.containerMask = resourceManager.get(
    "buyABonusContainer:buyBonusPopup:containerMask"
  );
  // buyBonusPopup.containerMask.beginFill(0xffffff);
  // buyBonusPopup.containerMask.lineStyle(0, 0xffffff);
  // buyBonusPopup.containerMask.drawRect(-border.width / 2, -1, border.width, 1);
  // buyBonusPopup.containerMask.pivot.y = -0.5;

  // buyBonusPopup.background.mask = buyBonusPopup.containerMask;

  // const duration = 0.5;
  // const offset = top.height * 2 + 4;

  // buyBonusPopup.maskTargetScale = border.height - 20;
  // buyBonusPopup.topPosition = -border.height / 2 + offset;
  // buyBonusPopup.bottomPosition = border.height / 2 - offset;

  // buyBonusPopup.yesButton.alpha = 0;
  // buyBonusPopup.noButton.alpha = 0;
  // buyBonusPopup.fadedMask.alpha = 0;

  // buyBonusPopup.open = false;

  // buyBonusPopup.showTimeline = gsap
  //   .timeline({ paused: true })
  //   .call(() => {
  //     buyBonusPopup.containerMask.scale.y = 1;
  //     buyBonusPopup.open = true;

  //     top.y = 0;
  //     top.alpha = 1;
  //     bottom.y = 0;
  //     bottom.alpha = 1;

  //     buyBonusPopup.yesButton.alpha = 0;
  //     buyBonusPopup.noButton.alpha = 0;
  //     buyBonusPopup.fadedMask.alpha = 0;
  //   })
  //   .to(
  //     buyBonusPopup.containerMask.scale,
  //     {
  //       duration: duration + 0.05,
  //       y: buyBonusPopup.maskTargetScale,
  //     },
  //     "<+0.1"
  //   )
  //   .to(
  //     buyBonusPopup.fadedMask,
  //     {
  //       duration,
  //       alpha: 1,
  //     },
  //     "<"
  //   )
  //   .to(
  //     top,
  //     {
  //       duration,
  //       y: buyBonusPopup.topPosition,
  //     },
  //     "<"
  //   )
  //   .to(
  //     bottom,
  //     {
  //       duration,
  //       y: buyBonusPopup.bottomPosition,
  //     },
  //     "<"
  //   )
  //   .to(
  //     [buyBonusPopup.yesButton, buyBonusPopup.noButton],
  //     {
  //       duration,
  //       alpha: 1,
  //     },
  //     "<"
  //   );
};

buyBonusPopup.onClosePopup = function (buyBonus) {
  soundManager.play("buttonPressed");

  buyBonusPopup.open = false;

  if (buyBonus) {
    buyBonusPopup.container.visible = false;

    buyBonusPopup.callback(buyBonus);

    buyBonusPopup.onStartBonusSpin();
  } else {
    // const top = resourceManager.get(
    //   "buyABonusContainer:buyBonusPopup:frameTop"
    // );
    // const bottom = resourceManager.get(
    //   "buyABonusContainer:buyBonusPopup:frameBottom"
    // );
    // const duration = 0.5;
    // buyBonusPopup.closeTimeline = gsap
    //   .timeline()
    //   .call(() => {
    //     buyBonusPopup.open = false;
    //   })
    //   .to(
    //     buyBonusPopup.containerMask.scale,
    //     {
    //       duration: duration + 0.03,
    //       y: 1,
    //     },
    //     "<+0.1"
    //   )
    //   .to(
    //     buyBonusPopup.fadedMask,
    //     {
    //       duration,
    //       alpha: 0,
    //     },
    //     "<"
    //   )
    //   .to(
    //     top,
    //     {
    //       duration,
    //       y: 0,
    //     },
    //     "<+0.02"
    //   )
    //   .to(
    //     bottom,
    //     {
    //       duration,
    //       y: 0,
    //     },
    //     "<"
    //   )
    //   .to(
    //     [buyBonusPopup.yesButton, buyBonusPopup.noButton],
    //     {
    //       duration,
    //       alpha: 0,
    //     },
    //     "<"
    //   )
    //   .to([top, bottom], {
    //     duration: 0.15,
    //     alpha: 0,
    //   })
    //   .call(() => {
    buyBonusPopup.container.visible = false;
    buyBonusPopup.callback(buyBonus);
    messageBus.post("game:modal", {});
    //   });
  }
};

buyBonusPopup.onBalanceEvent = function (event) {
  buyBonusPopup.balance = event.data.balance;
};

buyBonusPopup.onStartBonusSpin = function () {
  gameController.inBuyABonus = true;
  gameData.winningsMeter.set(0);
  let stakeController = resourceManager.getController("stakeController");

  messageBus.post("game:modal", {});

  const bonusBuyStakes =
    buyBonusPopup.gameConfig.data.slotConfig.gameModes.BONUS_BUY.coinSizes;
  let baseStake = buyBonusPopup.convertToTotalStake(
    bonusBuyStakes[buyBonusPopup.currentStakeIndex]
  );
  let stakes = stakeController.Stakes;
  let returnStake = stakes.find((stake) => stake === baseStake);

  if (!returnStake) {
    returnStake = stakes[0];
  }

  stakeController.requestChangeStake(returnStake);
  stakeController.requestChangeStake(baseStake, "BONUS_BUY");

  var bpl = baseStake / stakeController.CurrentWinLineCount;

  gdk.startGame(
    {
      stake: baseStake * buyBonusPopup.gameConfig.data.buyBonusCost,
      numWinlines: stakeController.CurrentWinLineCount,
      bpl: bpl,
      metaData: {
        encore: gameData.encoreEnabled,
        buyABonus: true,
      },
    },
    function () {
      gdk.getNextGameOutcome(function () {});
    }
  );
};

buyBonusPopup.orientationChange = function () {
  // if (buyBonusPopup.open) {
  // const top = resourceManager.get(
  //   "buyABonusContainer:buyBonusPopup:frameTop"
  // );
  // const bottom = resourceManager.get(
  //   "buyABonusContainer:buyBonusPopup:frameBottom"
  // );
  // buyBonusPopup.containerMask.scale.y = buyBonusPopup.maskTargetScale;
  // top.y = buyBonusPopup.topPosition;
  // bottom.y = buyBonusPopup.bottomPosition;
  // }
};

buyBonusPopup.onGameConfig = function (event) {
  buyBonusPopup.gameConfig = event;
  buyBonusPopup.init();
};

buyBonusPopup.onClickedYes = function () {
  buyBonusPopup.onClosePopup(true);
};

buyBonusPopup.onClickedNo = function () {
  buyBonusPopup.open = false;

  messageBus.post("game:modal", {});

  buyBonusPopup.onClosePopup(false);
};

buyBonusPopup.onInfo = function () {
  soundManager.play("buttonPressed");
  gameData.helpPageScroll.open();
};

buyBonusPopup.getFilesRequired = function (json) {
  return [];
};

resourceManager.registerObjectType(
  "buyBonusPopup",
  buyBonusPopup.create,
  buyBonusPopup.initialise,
  buyBonusPopup.getFilesRequired
);
